
import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface BiographySectionProps {
  formData: {
    bio: string;
    short_description: string;
  };
  onInputChange: (field: string, value: string) => void;
}

export default function BiographySection({ formData, onInputChange }: BiographySectionProps) {
  return (
    <>
      <div>
        <Label htmlFor="bio">Biography</Label>
        <Textarea
          id="bio"
          value={formData.bio}
          onChange={(e) => onInputChange('bio', e.target.value)}
          rows={4}
        />
      </div>

      <div>
        <Label htmlFor="short_description">Short Description</Label>
        <Textarea
          id="short_description"
          placeholder="Brief summary for profile cards"
          value={formData.short_description}
          onChange={(e) => onInputChange('short_description', e.target.value)}
          rows={2}
        />
      </div>
    </>
  );
}
